import { Col } from 'hb-react/shared/components/DesignSystem/Grid';

const ListFilters = ({ filterItems, filtersValues, onChange, colWidth }) =>
  filterItems.map(({ id, component: Component }) => (
    <Col data-testid="filters-filter" key={id} width={colWidth}>
      <Component
        id={id}
        value={filtersValues?.[id]}
        onChange={(value) => onChange({ [id]: value })}
      />
    </Col>
  ));

export default ListFilters;
